import * as React from 'react';
var defaultValue = {
  current: null
};

if (typeof document !== 'undefined') {
  defaultValue = {
    current: document.body
  };
}

export var ScrollContainerContext = React.createContext(defaultValue);
export var ScrollContainerProvider = ScrollContainerContext.Provider;
export var useScrollContainer = function useScrollContainer() {
  var ref = React.useContext(ScrollContainerContext);
  return {
    ref: ref,
    scrollTo: function scrollTo(_a) {
      var x = _a.x,
          y = _a.y,
          _b = _a.behavior,
          behavior = _b === void 0 ? 'auto' : _b;

      if (ref && ref.current) {
        ref.current.scrollTo({
          left: x,
          top: y,
          behavior: behavior
        });
      }
    }
  };
};